<template>
  <div :class="$options.name">
    <v-row>
      <v-col>
        <v-data-iterator
          :items="list"
          :no-data-text="'Нет данных для отображения'"
          :items-per-page="1000"
          hide-default-footer
        >
          <template #header>
            <v-card v-permission="['icon-edit']" class="mb-2">
              <v-toolbar dark color="blue darken-3" flat>
                <v-btn
                  v-permission="['icon-create']"
                  color="primary"
                  dark
                  class="elevation-0 mr-6"
                  @click="dialog = true"
                >
                  Создать новую
                </v-btn>

                <v-text-field
                  v-model="search"
                  label="Поиск по названию, описанию или тегу"
                  prepend-inner-icon="search"
                  flat
                  clearable
                  single-line
                  hide-details
                  @input="doSearch"
                />

                <v-progress-linear
                  indeterminate
                  absolute
                  bottom
                  color="white"
                  :active="loading"
                />
              </v-toolbar>
            </v-card>
          </template>

          <template #default="{ items }">
            <v-row>
              <v-col
                v-for="item in items"
                :key="item.id"
                cols="12"
                sm="6"
                md="2"
                lg="2"
              >
                <v-card
                  :raised="activeItem && item.id === activeItem.id"
                  hover
                  @click="iconItemClick(item)"
                >
                  <v-card-text class="d-flex justify-center pa-2 flex-column align-center">
                    <v-img
                      :src="item.file.path"
                      width="48"
                      height="48"
                      class="icon__image"
                    />
                    <div
                      class="mt-2 mb-1 overflow-hidden text-no-wrap text-truncate text-center w-100"
                    >
                      <span>{{ item.name }}</span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <template v-if="pagination" #footer>
            <v-pagination
              :length="pagination.lastPage"
              :total-visible="8"
              :value="pagination.currentPage"
              :disabled="pagination.lastPage === 1"
              class="pb-4 pt-4"
              @next="onChangePage(pagination.currentPage + 1)"
              @previous="onChangePage(pagination.currentPage - 1)"
              @input="onChangePage($event)"
            />
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>

    <icon-edit-dialog
      v-if="dialog"
      v-model="dialog"
      v-permission="['icon-edit']"
      :icon="activeItem"
      :tags="tagsFullList"
      @close="dialogClosed"
      @saved="dialogCompleted"
      @deleted="dialogCompleted"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import IconEditDialog from '@/views/references/icons/components/IconEditDialog.vue';

export default {
  name: 'references-icons-list-view',

  asyncData({ store }) {
    return Promise.all([
      store.dispatch('icons/getList'),
      store.dispatch('tags/getFullList'),
    ]);
  },

  components: { IconEditDialog },

  data: () => ({
    search: sessionStorage.getItem('icons-search') || '',
    dialog: false,
    selectedFiles: null,
    loading: false,
    activeItem: null,
    itemIsDeleting: false,
    formValid: true,
  }),

  computed: {
    ...mapState('icons', ['list', 'pagination']),
    ...mapState('tags', { tagsFullList: 'fullList' }),
  },

  methods: {
    ...mapActions('icons', ['create', 'update', 'remove', 'getNextPage', 'getList']),
    ...mapActions('tags', { tagsGetFullList: 'getFullList' }),
    ...mapActions(['showNotify']),

    async onChangePage(page) {
      this.loading = true;

      await this.getNextPage({ page, query: this.search });

      this.loading = false;
    },

    iconItemClick(item) {
      this.activeItem = { ...item };
      this.dialog = true;
    },

    dialogClosed() {
      this.dialog = false;
      this.activeItem = null;
    },

    async dialogCompleted() {
      this.dialogClosed();

      this.loading = true;

      await this.tagsGetFullList();
      await this.getList({ query: this.search });

      this.loading = false;
    },

    // eslint-disable-next-line func-names
    doSearch: debounce(async function () {
      this.loading = true;

      await this.getList({ query: this.search });

      sessionStorage.setItem('icon-search', this.search);

      this.loading = false;
    }, 750),
  },
};
</script>
